import { useLocation } from 'react-router-dom';
import {
  IntegrationsTab,
  IntegrationsTabType,
} from './IntegrationsTabs.constants';

const useIntegrationsActiveTab = (): IntegrationsTabType => {
  const { pathname } = useLocation();

  const defaultTab = IntegrationsTab.featured;

  return (
    Object.values(IntegrationsTab).find((tab) =>
      pathname.endsWith(`/${tab}`),
    ) ?? defaultTab
  );
};

export default useIntegrationsActiveTab;
